import { getStoredEnvironment } from '../context/EnvironmentContext';

export const ENVIRONMENT_HEADER = 'X-Environment';

const BACKEND_PATH_PREFIXES = ['/v1/', '/items', '/boxes', '/v1/packaging'];

function getApiBaseUrls() {
  return [
    process.env.REACT_APP_AUTH_IDENTITY_API_URL,
    process.env.REACT_APP_CLIENT_CORE_API_URL,
    process.env.REACT_APP_DELIVERY_CORE_API_URL,
    process.env.REACT_APP_WEBHOOKS_API_URL,
    process.env.REACT_APP_PACKAGING_API_URL,
    process.env.REACT_APP_API_BASE_URL,
  ]
    .map((value) => String(value || '').trim().replace(/\/+$/, ''))
    .filter(Boolean);
}

export function shouldAttachEnvironmentHeader(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    if (BACKEND_PATH_PREFIXES.some((prefix) => parsed.pathname.startsWith(prefix))) {
      return true;
    }
    const target = `${parsed.origin}${parsed.pathname}`.replace(/\/+$/, '');
    return getApiBaseUrls().some(
      (base) => target === base || target.startsWith(`${base}/`),
    );
  } catch {
    return false;
  }
}

export function withEnvironmentHeader(headersInit) {
  const headers = new Headers(headersInit);
  if (!headers.has(ENVIRONMENT_HEADER)) {
    headers.set(ENVIRONMENT_HEADER, getStoredEnvironment());
  }
  return headers;
}

export function prepareBackendFetch(input, init = {}) {
  const url = typeof input === 'string' ? input : input.url;
  if (!shouldAttachEnvironmentHeader(url)) {
    return { input, init };
  }

  const headers = withEnvironmentHeader(
    init?.headers ?? (input instanceof Request ? input.headers : undefined),
  );

  if (input instanceof Request) {
    return {
      input: new Request(input, { ...init, headers }),
      init: undefined,
    };
  }

  return {
    input,
    init: { ...init, headers },
  };
}

export function buildConsoleRequestHeaders(token, user, extraHeaders = {}) {
  const headers = {
    Authorization: `Bearer ${token}`,
    [ENVIRONMENT_HEADER]: getStoredEnvironment(),
    ...extraHeaders,
  };
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  if (!roles.includes('administrator')) {
    return headers;
  }
  const companyId =
    user?.activeCompany?.id ??
    user?.activeCompany?.company_id ??
    user?.activeCompany?.companyId;
  if (companyId != null && String(companyId).trim() !== '') {
    headers['X-Company-Id'] = String(companyId);
  }
  return headers;
}
